<div data-cy="email-log-dropzone__page" class="dropzone-previews"></div>
<div class="dropzone-container">
  <dropzone #dropzone [message]="text || 'Sleep hier je e-mail/agenda-items in.'" [config]="dropzoneConfig" (error)="onUploadDropzoneError($event)"></dropzone>
</div>
